export const mutations = {
  setCidade(state, data) {
    state.cidade = data;
  },
  setCidades(state, data) {
    state.cidades = data;
  },
};

export default {};
